// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1kYdK","addWidgetButton":"Header_addWidgetButton__1mLuV","dashboardTabs":"Header_dashboardTabs__3V9pE","active":"Header_active__1kIUW"};